/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};
(function ($) {
  'use strict';
  /**
   *  Вид для претензии.
   */
  app.ClaimItemView = app.ClaimUploadFormView.extend({
    formElement: '.field',
    events: {
      'click .reset-qty': 'resetQty',
      'click .remove-item, .remove-item-text': 'removeItem',
      'blur .invoice_number': 'updateInvoiceNumber',
      'blur .sid': 'updateItemSid',
      'click .select-input .field_input, .with-icon_arrowdown-blue': 'showPopup',
      'click .select-input .with-icon_arrowup-blue': 'hidePopup',
      'click .scrollable li': 'selectOption',
      'blur .damaged input, .qty input, .not-full input': 'updateQty',
      'blur .received input': 'updateReceivedQty',
      'blur .ordered input': 'updateOrderedQty',
      'blur .claim-comment textarea': 'updateComment',
      'click .photo-remove': 'removePhoto',
      'change .fileupload': 'photoUpload',
      'click .fileupload-wrapper label': 'checkPhotoLoad',
      'keyup .claim-qty input': 'inputKeyUp'
    },
    run: function () {
      app.ClaimUploadFormView.prototype.run.apply(this, arguments);
      this.template = app.helpers.TemplateHelper.getTemplate('#new-claim-item-row');
      this.editClaimTemplate = app.helpers.TemplateHelper.getTemplate('#edit-claim-item');
      this.listenTo(this.model, 'remove', this.remove);
      this.initPopup();
      this.notLoaded = [];
      this.isSaving = false;
    },
    render: function (element) {
      if (!element) {
        element = $(this.template({
          model: this.model.toJSON()
        }));
        this.$el.replaceWith(element);
      }
      this.setElement(element);
      return this;
    },

    /**
     * Инициализация попапа
     */
    initPopup: function () {
      var opener = this.$('.js-edit-claim'),
        popup = $('#claim-edit-popup-' + this.model.get('id')),
        claimEditForm = this.editClaimTemplate({model: this.model.toJSON()}),
        css,
        indent = 160;
      this.popup = new als.Popup(popup, opener);
      this.popup.addEventListener(
        als.Popup.EventType.BEFORE_OPEN,
        function () {
          var offsetLeft = opener.parent().offset().left;
          var offsetTop = window.pageYOffset + indent;
          if (!app.isDesktop) {
            offsetLeft = offsetLeft - $('body').position().left;
            offsetTop = offsetTop - $('body').position().top;
          }
          css = {
            left: offsetLeft,
            top: offsetTop
          };
          popup.find('.claim-edit').html(claimEditForm);
          popup.css(css);
        }
      );
    },

    /**
     * Изменение направления стрелки.
     */
    arrowSelectUp: function () {
      this.$('.with-icon_arrowdown-blue').addClass('with-icon_arrowup-blue').removeClass('with-icon_arrowdown-blue');
    },
    arrowSelectDown: function () {
      this.$('.with-icon_arrowup-blue').removeClass('with-icon_arrowup-blue').addClass('with-icon_arrowdown-blue');
    },
    /**
     * Отображение блока с опциями.
     */
    showPopup: function (e) {
      e.stopPropagation();
      this.selectOptions = this.$('.select-options');
      this.selectInput = this.$('.select-input .prevent-close-popup');
      this.popupOpen = true;
      this.selectOptions.find('.b-popup').removeClass('not_display');
      this.arrowSelectUp();
      this.listenTo(Backbone, 'bodyView:click', this.hidePopupSpecial.bind(this, e));
    },
    /**
     * Выбор опции.
     * @param {object} e
     */
    selectOption: function (e) {
      var target = $(e.target),
        selectedOption = target.text(),
        selectedId = target.data('select-id'),
        that = this,
        noPhotosOption = 3;
      if (selectedId === noPhotosOption && this.model.get('photos')){
        var $deffered=[];
        _.each(this.model.get('photos'), function (photo) {
          $deffered.push(that.removeApiPhoto(photo.id));
        });
        $.when.apply($, $deffered).done(function () {
          that.$('.claim-photo-block').remove();
          that.model.unset('photos');
        });
      }
      if (selectedId === undefined) {
        selectedId = 1;
      }
      this.selectInput.val(selectedOption);
      this.hidePopup(e);
      this.$fields = this.$el.find(this.formElement);
      var key = {
        'claim_item_reason_id': selectedId,
        'claim_item_reason_title': selectedOption
      };
      this.selectSaveMethod(key);
      this.render();
      this.$('.fileupload').hide();
    },
    /**
     * Скрытие блока с опциями.
     */
    hidePopup: function (e) {
      e.stopPropagation();
      if (this.popupOpen) {
        this.selectOptions.find('.b-popup').addClass('not_display');
        this.arrowSelectDown();
      }
      $('body').off('click', this.hidePopupSpecial.bind(this, e));
    },
    hidePopupSpecial: function (e) {
      if (!$(e.target).hasClass('prevent-close-popup')) {
        this.hidePopup(e);
      }
    },
    /**
     * Сбрасываем количество до единицы.
     * @param e
     */
    resetQty: function (e) {
      var $target = $(e.target),
        $parent = $($target.parents('.claim-qty-btn')),
        key,
        value = 1;
      $target.siblings('input').val(1);
      if ($parent.hasClass('ordered')) {
        key = 'ordered';
      } else if ($parent.hasClass('received')) {
        key = 'received';
      } else {
        key = 'qty';
      }
      this.selectSaveMethod(key, value);
    },
    /**
     * Обновление номера накладной в модели.
     * @param e
     */
    updateInvoiceNumber: function (e) {
      var key = 'invoice_number',
        value = $(e.target).val();
      this.selectSaveMethod(key, value);
    },
    /**
     * Обновление артикула товара в модели.
     * @param e
     */
    updateItemSid: function (e) {
      var key = 'sid',
        value = $(e.target).val();
      this.selectSaveMethod(key, value);
    },
    /**
     * Обнровление количества товара в модели.
     * @param e
     */
    updateQty: function (e) {
      var value = $(e.target).val(),
        key = 'qty';
      if (value <= 0) {
        $(e.target).val(1);
        value = 1;
      }
      this.selectSaveMethod(key, value);
    },
    updateReceivedQty: function (e) {
      var value = $(e.target).val(),
        key = 'received_qty',
        condition = this.model.get('claim_item_reason_id') === 3 ? 0 : 1;
      /* если причина недовложение, количество может быть нулевым */
      if (value < condition || !value) {
        $(e.target).val(1);
        value = 1;
      }
      this.selectSaveMethod(key, value);
    },
    updateOrderedQty: function (e) {
      var value = $(e.target).val(),
        key = 'ordered_qty',
        condition = this.model.get('claim_item_reason_id') === 5 ? 0 : 1;
      /* если причина излишки, количество может быть нулевым */
      if (value < condition || !value) {
        $(e.target).val(1);
        value = 1;
      }
      this.selectSaveMethod(key, value);
    },
    /**
     * Обновление комментария в модели.
     * @param e
     */
    updateComment: function (e) {
      var key = 'comment',
        value = $(e.target).val();
      this.selectSaveMethod(key, value);
    },
    /**
     * Удаление товара.
     */
    removeItem: function () {
      this.model.destroy();
    },
    /**
     * Сохранение свойства в модели.
     * @param key
     * @param value
     */
    saveModel: function (key, value) {
      this.isSaving = true;
      var that = this,
        options = {
          success: function () {
            that.clearErrors();
            that.model.set('valid', true);
            that.isSaving = false;
            // проверяем, есть ли незагруженные фотки
            if (that.notLoaded.length) {
              var deferred = [],
                loaded = [];
              // сохраняем запросы в массив deferred
              while (that.notLoaded.length) {
                var photoForm = that.notLoaded.shift();
                photoForm.append('claim_item_id', that.model.get('id'));
                deferred.push(that.postFormData(photoForm, loaded));
              }
              // после того как все запросы закончатся выполняем рендер
              $.when.apply($, deferred).done(function () {
                that.model.set('photos', loaded);
                that.render();
              });
            } else {
              that.render();
            }
          },
          error: function (model, response) {
            if (that.showError) {
              that.error(model, response);
            }
            that.model.set('valid', false);
            that.isSaving = false;
          }
        };
      if (key === null || typeof key === 'object') {
        value = options;
      }
      this.$fields = this.$el.find(this.formElement);
      return this.model.save(key, value, options);
    },
    /**
     * Удаление добавленной фотографии.
     * @param e
     */
    removePhoto: function (e) {
      var $parent = $(e.target).parents('.claim-photo-block'),
        allPhotos = this.$('.photo-thumbnails').children(),
        index = allPhotos.index($parent),
        id = $parent.data('photo-id');
      if (!id) {
        this.notLoaded.splice(index, 1);
      }
      $parent.remove();
      // если фотки еще нет на сервере, не нужно отправлять запрос на удаление
      if (id) {
        this.removeApiPhoto(id);
      }
    },
    removeApiPhoto: function (id) {
        return $.ajax({
          url: '/api/v3/claim-item-photo/' + id + '/',
          method: 'DELETE'
        });
    },
    /**
     * Заполнение ошибок
     * @param {array} errors массив ошибок формы
     */
    fillErrors: function (errors) {
      var that = this;
      errors.forEach(function (error) {
        that.$('.' + error.field + '-error').text(error.message);
        that.$('.' + error.field).addClass('error');
        if (error.field === 'comment') {
          that.$('.comment-message').css('color', '#fb3a2f');
        }
      });
      this.$('.fileupload').hide();
    },
    /**
     * Очистка ошибок
     */
    clearErrors: function () {
      this.$fields.each(function () {
        $(this).removeClass('error');
      });
      this.$('.error-message').text('');
      this.$('.comment-message').css('color', '#bab6ad');
      this.$('.fileupload').show();
    },
    /**
     * Сохранение модели на сервер и показ ошибок.model.set
     * @returns {promise}
     */
    validateModel: function () {
      this.showError = true;
      return this.saveModel(null);
    },
    /**
     * Вырезаем в поле ввода любые символы кроме цифр.
     */
    inputKeyUp: function (e) {
      var $input = $(e.target);
      $input.val($input.val().replace(/([^0-9])/g, ''));
    },
    /**
     * Проверяем, валидны ли заполненные поля, прежде чем загружать фото,
     * если запрос уже ушел, ничего не делаем.
     */
    checkPhotoLoad: function () {
      if (!this.isSaving) {
        this.validateModel();
      }
    },
    selectSaveMethod: function (key, value) {
      if (this.$('.error').length === 0) {
        this.model.set(key, value);
      } else {
        this.saveModel(key, value);
      }
    }
  });
})(jQuery);

}.call(window));